module.exports = __webpack_public_path__ + "img/copy_outlined_32.e304fa3a.svg";